import { ADMIN_HOME_HERO_PREVIEW_GROUPS, ADMIN_HOME_HERO_PREVIEW_MODES } from './homeHeroPreviewModes'

export default function HomeHeroStateSelector({
  value,
  onChange = () => {},
  maintenancePreview = false,
  onMaintenancePreviewChange = () => {},
}) {
  return (
    <nav className="admin-home-state-selector" aria-label="히어로 상태 선택">
      <h2>상태</h2>
      {ADMIN_HOME_HERO_PREVIEW_GROUPS.map(group => (
        <section key={group.id} className="admin-home-state-selector__group" aria-labelledby={`preview-group-${group.id}`}>
          <h3 id={`preview-group-${group.id}`}>{group.label}</h3>
          <div className="admin-home-state-selector__list">
            {ADMIN_HOME_HERO_PREVIEW_MODES.filter(mode => mode.group === group.id).map(mode => {
              const active = value === mode.id && !maintenancePreview
              return (
                <button
                  key={mode.id}
                  type="button"
                  className={`admin-home-state-selector__item${active ? ' active' : ''}`}
                  aria-pressed={active}
                  onClick={() => {
                    onMaintenancePreviewChange(false)
                    onChange(active ? null : mode.id)
                  }}
                >
                  <span className="admin-home-state-selector__dot" aria-hidden="true">{active ? '●' : '○'}</span>
                  <span><strong>{mode.label}</strong><small>{mode.description}</small></span>
                </button>
              )
            })}
          </div>
        </section>
      ))}

      <section className="admin-home-state-selector__group admin-home-state-selector__operations" aria-labelledby="preview-group-operations">
        <h3 id="preview-group-operations">운영 상태</h3>
        <button type="button" className={`admin-home-state-selector__item${maintenancePreview ? ' active' : ''}`} aria-pressed={maintenancePreview} onClick={() => {
          onMaintenancePreviewChange(!maintenancePreview)
        }}>
          <span className="admin-home-state-selector__dot" aria-hidden="true">{maintenancePreview ? '●' : '○'}</span>
          <span><strong>홈 시스템 점검</strong><small>실제 CMS 설정은 변경하지 않는 Preview</small></span>
        </button>
        {maintenancePreview && <span className="admin-home-state-selector__preview-link">미리보기 적용 중</span>}
      </section>
    </nav>
  )
}
